module.exports = __webpack_public_path__ + "static/media/newsletter-september-2018-st-innocent.3d4bb011.png";